
import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { API } from "aws-amplify";
import TitleHeader from "./titleHeader";
import ModalMessage from "../Components/modalMessage";
import ModalConfirm from "../Components/modalConfirm";
import ModalImproveRate from "../Components/modalImproveRate";
import Loading from "../Components/loading";
import { openModalImproveRate } from "../Store/improveRate/actions";
import { ToastContainer } from "react-toastify";
import { decryptEstandar } from "../Utils/CryptographyUtils";
import { getTitleCase } from "../Utils/simulaciones/simulaciones";
import BreadCrumbs from "./BreadCrumbs";
import { InputsSearchBy } from "./wizard/FormElements/InputsSearchBy";
import { modalSteps, resetRedux } from "../Store/simulate/actions";
import Chip from "./wizard/FormElements/Chip";
import GirlImage from "../Resources/svg/human/GirlImage";
import IconBack from "../Resources/svg/Icons/IconBack";
import IconFilter from "../Resources/svg/Icons/IconFilter";
import IconDelete from "../Resources/svg/Icons/IconDelete";
import IconErrorLight from "../Resources/svg/Icons/IconErrorLight";
import { weftType } from '../Utils/constants';
import ModalSide from "./wizard/FormElements/ModalSide";
import Tabs from "../Components/FormElements/tabs";
import Pagination from "../Components/FormElements/pagination";
import TotalTable from "../Components/FormElements/totalTable";
import TableSimulation from "../Components/FormElements/tableSimulation";
import Footer from "../Components/Footer";
import Button from "../Components/FormElements/Button";
import ModalFiltering from "../Components/FormElements/ModalFiltering";
import SpinnerTable from "../Components/SpinnerTable";
import AlertNotifications from "../Components/FormElements/AlertNotifications";

export default function ListSimulations() {
  const channel = useSelector((state) => state.login.channel);
  const history = useHistory();

  const asesorSel = useSelector((state) =>
    decryptEstandar(state.login.idClient)
  );
  const listProducts = [
    { code: "IG", name: "Inversión global" },
    { code: "RG", name: "Renta garantizada" },
    { code: "UC", name: "Inversión Global Ultra Cash" },
  ];

    if (channel === "admin") {
    listProducts.push({ code: "RVEO", name: "Renta Vitalicia" });
  }

  const param = new URLSearchParams(window.location.search);
  const tabProduct = param.get("tab");
  const initialProduct =
    (tabProduct && listProducts.find((prod) => prod.code === tabProduct)) ||
    listProducts[0];

  const [modalData, setModalData] = useState({});
  const [stateEmision, setStateEmision] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [searchType, setSearchType] = useState(
    initialProduct.code === "RVEO" || initialProduct.code === "RV" ? "nroOperacion" : "documento"
  );
  const [activeProduct, setActiveProduct] = useState(initialProduct.name);
  const [activeProductCode, setActiveProductCode] = useState(
    initialProduct.code
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [keyPages, setKeyPages] = useState(null);

  const [tableQuote, setTableQuote] = useState([]);
  const [loading, setLoading] = useState(false);

  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const [dataModalConfirm, setDataModalConfirm] = useState(null);
  const [messageConfirm, setMessageConfirm] = useState("");
  const [openModalMessage, setOpenModalMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [typeMessage, setTypeMessage] = useState("");
  const [itemModalImproveRate, setItemModalImproveRate] = useState(null);

  const loadingInproveRate = useSelector((state) => state.improveRate.loading);
  const rate = useSelector((state) => state.improveRate.rate);
  const isOpenModalImproveRate = useSelector(
    (state) => state.improveRate.isOpen
  );
  const dispatch = useDispatch();

  const [selectedOption, setSelectedOption] = useState({});

  const [params, setParams] = useState({
    page: 1,
    limit: 6,
    state: "todas",
    codProd: activeProductCode,
    haveKey: false,
    keyPage: null,
    asesor: null,
    emailAdviser: selectedOption.value || null,
  });

  const [withParams, setWithParams] = useState(false);

  const timerToClear = useRef(false);
  const limitPage = 6;
  const options = {
    // simulacionId: "Nro. de simulación",
    documento: "DNI/CE",
    nombres: "Nombres y apellidos",
  };

  const handleStateClose = () => {
    document
      .querySelectorAll("select")
      .forEach((x) => (x.options.selectedIndex = 0));

    setParams({
      ...params,
      state: "todas",
    });
  };
 
  const handleAsesorClose = () => {
    setSelectedOption({
      label: "",
      value: "",
    });
    document
      .querySelectorAll('input[type="input"]')
      .forEach((x) => (x.value = ""));
    setSearchInput("");
    const data = {
      ...params,
      page: 1,
      haveKey: false,
      keyPage: null,
    };
    delete data["filter"];
    data.filter = {
      key: searchType,
      value: "",
    };
    setParams({
      ...params,
      emailAdviser: "",
    });
  };

  const handleDNIClose = () => {
    document
      .querySelectorAll('input[type="input"]')
      .forEach((x) => (x.value = ""));
    setSearchInput("");
    const data = {
      ...params,
      page: 1,
      haveKey: false,
      keyPage: null,
    };
    delete data["filter"];
    data.filter = {
      key: searchType,
      value: "",
    };
    setParams(data);
  };

  const handleChangeSearch = (event) => {
    const val = event.target.value;
    let validateNumber = /^([0-9])*$/.test(val);
    if (searchType === "documento") {
      if (!validateNumber) {
        return false;
      }
    }
    setSearchInput(val.toUpperCase());

    clearTimeout(timerToClear.current);
    timerToClear.current = setTimeout(() => {
      const data = {
        ...params,
        page: 1,
        haveKey: false,
      };
      delete data["filter"];
      if (val !== "") {
        data.filter = {
          key: searchType,
          value: val.toUpperCase(),
        };
      }
      setParams(data);
    }, 1000);
  };

  const handleChangeSelect = (event) => {
    const val = event.target.value;
    // if (val === "simulacionId") {
    setSearchInput("");
    // }
    setSearchType(val);
  };

  const handleChangeState = (event) => {
    const val = event.target.value;

    setParams({
      ...params,
      page: 1,
      state: val,
      haveKey: false,
      keyPage: null,
    });

    const filtering = val[0].toUpperCase() + val.substring(1);

    window.digitalData.push({
      metadata: {
        key: "Estado de Simulación",
        value: filtering,
      },
      event: "trackMetadata",
    });
  };

  const handleClickProduct = (val) => {
    setActiveProduct(val);

    let code = listProducts.filter((obj) => {
      return obj.name === val;
    })[0].code;
    setActiveProductCode(code);
    setParams({
      ...params,
      page: 1,
      codProd: code,
      haveKey: false,
    });

    const textTransForm = getTitleCase(val);

    window.digitalData.push({
      action: {
        group: "Simulaciones",
        category: "Listado",
        name: "Tabs",
        label: textTransForm,
      },
      event: "trackAction",
    });
  };

  const setCustomPage = (page) => {
    if (currentPage !== page) {
      setCurrentPage(page);
      setParams({
        ...params,
        page: page,
        haveKey: true,
        keyPage: keyPages[page - 2] || null,
      });
    }
  };

  const handleReset = () => {
    document
      .querySelectorAll('input[type="input"]')
      .forEach((x) => (x.value = ""));
    document
      .querySelectorAll("select")
      .forEach((x) => (x.options.selectedIndex = 0));
    params.asesor = asesorSel;
    params.emailAdviser = asesorSel;
    setSearchInput("");
    setSearchType("");
    const data = {
      ...params,
      page: 1,
      haveKey: false,
    };
    delete data["filter"];
    data.filter = {
      key: searchType,
      value: "",
    };
    setParams(data);
  };

  const getQuotes = async () => {
    setLoading(true);
    setWithParams(params.filter && params.filter.value);

    const isRv = params.codProd === "RV" || params.codProd === "RVEO";
    const apiName = isRv ? "cotizacion-extraoficial" : "api-rentas";
    const endpoint = isRv ? "/extraoficial/listar" : "/simulaciones";
    const request = isRv
      ? { body: { payload: params } }
      : { body: params };

    const response = await API.post(apiName, endpoint, request);
    const { data, last_page, total, keys } = isRv ? response.payload : response;
    setCurrentPage(params.page);
    setTableQuote(data);
    if (data === undefined) {
      window.digitalData.push({
        error: {
          code: "ErrorInversionGlobal",
          message: "No carga la información",
        },
        event: "trackError",
      });
      history.push("/cotizaciones/error-simulacion", {
        timeOut: false,
      });
    }
    if (keys) {
      console.log("total", data);
      setLastPage(last_page);
      setTotalItems(total);
      setKeyPages(keys);
    }
    setLoading(false);
  };

  useEffect(() => {
    getQuotes();
  }, [params, rate]);

  useEffect(() => {
    dispatch(resetRedux());

    window.digitalData.push({
      virtual: {
        name: "aiv:listado-simulaciones",
      },
      event: "trackVirtual",
    });
  }, []);

  const reactiveSimulation = (item, index) => {
    setDataModalConfirm({ item, index });
    setMessageConfirm(`¿Desea activar la simulación Nº ${item.numSimulacion}?`);
    setOpenModalConfirm(true);
  };

  const closeModalImproveRate = () => dispatch(openModalImproveRate(false));

  const goToDetail = (item) => {
    history.push({
      pathname: "/simulaciones/detalle",
      item: item,
    });
  };
  const processReactiveSimulation = async (data) => {
    const { item, index } = data;
    const isAdmin = channel === "admin";
    setLoading(true);
    const response = await API.post("api-rentas", "/activate-simulation", {
      body: { simulationId: item.idSimulacion, isAdmin },
    });
    setLoading(false);
    setMessage(response.message);
    setTypeMessage(response.status ? "success" : "error");
    setOpenModalMessage(true);
    if (response.status) {
      const newData = [...tableQuote];
      newData[index].estado = "Vigente";
      newData[index].datosSimulacion.vencimiento =
        response.data.expirationFormat;
      setTableQuote(newData);
    }
  };

  return (
    <div>
      <div className="sectionSearch">
        <div className="wrap">
          <div className="content-box">
            <BreadCrumbs rutas={[{ link: "Simulaciones" }]} />
            <div className="back-responsive">
              <div className="back-responsive__box">
                <IconBack
                  className="nav-case__back"
                  onClick={() => history.push("/productos")}
                />
                <div className="back-responsive__text">Volver</div>
              </div>
            </div>
            <TitleHeader
              title="Listado de simulaciones"
              titleBold=""
              subtitle="Revisa las simulaciones que realizaste"
            />
          </div>
        </div>
      </div>
      <div className="sectionTable">
        <div className="wrap">
          <div className="content-box">
            <div className="sectionTable__text">Busca por:</div>
            <div className="filter" onClick={() => dispatch(modalSteps(true))}>
              <IconFilter />
              <div className="filter__text">Filtrar</div>
            </div>
            <div className="chip-content">
              {params.state !== "todas" && (
                <Chip
                  label={params.state}
                  handleCloseChip={handleStateClose}
                  variant="filtro"
                />
              )}
              {selectedOption.label !== "" && (
                <Chip
                  label={selectedOption.label}
                  handleCloseChip={handleAsesorClose}
                  variant="asesor"
                />
              )}
              {searchInput.length > 1 && (
                <Chip
                  label={searchInput}
                  handleCloseChip={handleDNIClose}
                  variant="asesor"
                />
              )}
            </div>

            <InputsSearchBy
              handleChangeState={handleChangeState}
              channel={channel}
              params={params}
              setParams={setParams}
              options={options}
              searchInput={searchInput}
              handleChangeSearch={handleChangeSearch}
              handleChangeSelect={handleChangeSelect}
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
            />
          </div>
          <Tabs
            values={listProducts.flatMap(({ name }) => name).join()}
            onClick={handleClickProduct}
            activeState={activeProduct}
          />
          <div className="content-box">
            {loading && (
              <>
                <SpinnerTable
                  title="¡Danos un momento!"
                  subtitle="Se está cargando la información."
                />
              </>
            )}
            {!loading && tableQuote.length > 0 && (
              <>
                <TotalTable limitPage={limitPage} totalItems={totalItems} />
                <div className="tab-shadow">
                  <TableSimulation
                    data={tableQuote}
                    setModalData={setModalData}
                    codProd={activeProductCode}
                    activeProduct={activeProduct}
                    activeProductCode={activeProductCode}
                    getQuotes={getQuotes}
                  />
                </div>
                <Pagination
                  currentPage={currentPage}
                  lastPage={lastPage}
                  setCurrentPage={setCustomPage}
                />
              </>
            )}
            {!loading && tableQuote.length < 1 && !withParams && (
              <div className="tableMessage">
                <IconErrorLight className="tableMessage__img" />
                <div className="tableMessage__empty">¡Ups! Lo sentimos.</div>
                <div className="tableMessage__message">
                  No encontramos resultados para tu búsqueda. Por favor,
                  verifica que el dato sea correcto.
                </div>
              </div>
            )}
            {!loading && tableQuote.length < 1 && withParams && (
              <div className="tableMessage">
                <GirlImage className="tableMessage__img" />
                <div className="tableMessage__empty">¡Lo sentimos!</div>
                <div className="tableMessage__message">
                  No encontramos resultados para el Nº de documento que
                  ingresaste. <br></br>
                  Revisa que sea el correcto o ingresa uno válido.
                </div>
              </div>
            )}
            {loadingInproveRate && <Loading />}
            <ToastContainer containerId={"A"} />
          </div>
        </div>
      </div>
      <ModalFiltering className="modal-result is-fullscreen">
        <h2 className="modal-result__title">Filtra tu búsqueda</h2>
        <div className="modal-result__desc">
          <InputsSearchBy
            handleChangeState={handleChangeState}
            channel={channel}
            params={params}
            setParams={setParams}
            options={options}
            searchInput={searchInput}
            handleChangeSearch={handleChangeSearch}
            handleChangeSelect={handleChangeSelect}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
          />
        </div>
        <div className="actions">
          <div className="actions__clean">
            <IconDelete />
            <div className="actions__text" onClick={handleReset}>
              Limpiar
            </div>
          </div>
          <Button
            className="actions__btn"
            onClick={() => dispatch(modalSteps(false))}
          >
            Buscar
          </Button>
        </div>
      </ModalFiltering>
      <ModalMessage
        open={openModalMessage}
        setOpen={setOpenModalMessage}
        message={message}
        type={typeMessage}
      />
      <ModalConfirm
        open={openModalConfirm}
        setOpen={setOpenModalConfirm}
        title="Activar simulación"
        message={messageConfirm}
        data={dataModalConfirm}
        acceptCallback={processReactiveSimulation}
      />
      <ModalSide
        modalData={modalData}
        handleSucessImprovements={() => getQuotes()}
        ri={false}
        loading={false}
        title="Detalle de Simulación"
        subtitle="Revisa los detalles de la simulación"
        stateTitle={false}
        setStateEmision={setStateEmision}
        weftType={ weftType.simulations }
      />
      <ModalImproveRate
        open={isOpenModalImproveRate}
        close={() => closeModalImproveRate()}
        item={itemModalImproveRate}
      />
      <AlertNotifications />
      <Footer />
    </div>
  );
}
